import React, { useState, useContext, useEffect } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import GenericButton from "../../components/GenericButton";
import workspaces from "../../services/api/workspaces";
import { GlobalContext } from "../../context/GlobalState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RoleContext } from "../../context/RoleContext";
import { Link, useRouteMatch, withRouter } from "react-router-dom";

const InviteForm = ({ history }) => {
  const [isLoading, setLoading] = useState(false);
  const [formActive, setFormActive] = useState(false);
  const { currentWorkspace } = useContext(GlobalContext);
  const {
    getWorkspaceUsers,
    setCreatedInvite,
    createdInvite,
    setSelectedUser,
    invitationEmail,
    setInvitationEmail,
  } = useContext(RoleContext);
  let { url } = useRouteMatch();

  useEffect(() => {
    if (createdInvite.role) {
      return;
    } else {
      setCreatedInvite({ role: "member" });
    }
  }, []);

  const handleDesktopSubmit = async (e) => {
    if (!invitationEmail) {
      return;
    }
    e.preventDefault();
    setLoading(true);
    try {
      const inviteData = {
        workspaceId: currentWorkspace.id,
        emailAddress: invitationEmail,
        role: createdInvite.role,
      };
      const response = await workspaces.inviteUser(inviteData);
      setInvitationEmail("");
      // setCreatedInvite({ role: "member" });
      setLoading(false);
      // console.log(response);
      getWorkspaceUsers();
    } catch (error) {
      console.log(error);
    }
  };

  const handleMobileSubmit = (e) => {
    e.preventDefault();
    if (!formActive) {
      setFormActive(true);
    } else {
      handleDesktopSubmit(e);
    }
  };

  const handleRoleClick = () => {
    setSelectedUser({ role: createdInvite.role });
    history.push(`${url}/permissions`);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setInvitationEmail(e.target.value);
  };

  const hideForm = () => {
    setFormActive(false);
  };

  return (
    <div className={container}>
      <div className={`inviteForm formActive desktop`}>
        <p>Invite New User</p>
        <form className="desktopRow" onSubmit={handleDesktopSubmit}>
          <div className="formInput">
            <div className="emailRow">
              <input
                type="text"
                placeholder="Email Address"
                onChange={handleChange}
                value={invitationEmail}
              ></input>
              <div className="role-container">
                <p onClick={() => handleRoleClick()}>
                  {createdInvite.role}
                  <span>
                <FontAwesomeIcon className="icon" icon="chevron-right" />
              </span>
                </p>
              </div>
            </div>
          </div>
          <GenericButton
            text="Send Invite"
            style="button"
            disabled={isLoading}
          />
        </form>
      </div>
      <form
        className={`inviteForm ${formActive ? "formActive" : ""} mobile`}
        onSubmit={handleMobileSubmit}
      >
        <div className="formInput">
          <p>Invite New User</p>
          <div className="emailRow">
            <input
              type="text"
              placeholder="Email Address"
              onChange={handleChange}
              value={invitationEmail}
            ></input>
            <div className="role-container">
            <p onClick={() => handleRoleClick()}>
              {createdInvite.role}
              <span>
                <FontAwesomeIcon className="icon" icon="chevron-right" />
              </span>
            </p>
            </div>
          </div>
        </div>
        <div className="newInvite">
          <GenericButton
            text={formActive ? "Send Invite" : "Invite New User"}
            style="button"
            disabled={isLoading}
          />
        </div>
        <div className="cancel" onClick={hideForm}>
          CANCEL
        </div>
      </form>
    </div>
  );
};

export default withRouter(InviteForm);

const container = css`
  width: 100%;
  
  .fa-chevron-right {
    margin-left: 3px;
    transform: rotate(90deg);
  }

  .desktop.formActive {
    p {
      font-size: ${textSizes.normal};
      font-weight: bold;
    }

    display: none;
    align-items: flex-start;
    padding: 30px 40px;
    .desktopRow {
      display: flex;
      align-items: center;
      padding: 5px 0;
      width: 100%;

      .button {
        width: 160px;
        font-weight: bold;
        font-size: 14px;
      }
      .formInput {
        height: initial;
        padding: 0;
      }
    }

    .inviteForm {
      flex-direction: row;
    }
  }

  .mobile {
    display: flex;
  }

  .inviteForm {
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: ${boxStyles.standardPadding};

    .formInput {
      /* background-color: red; */
      height: 0px;
      width: 100%;
      transition-duration: 1s;
      opacity: 0;
      
      p {
        font-size: ${textSizes.normal};
        color: ${colors.titleColor};
        padding: 0 0 4px 0;
        font-weight: bold;
      }

      .emailRow {
        display: flex;
        align-items: center;
        
        .role-container {
          height: 40px;
          border-radius: 0 8px 8px 0;
          border: 1px solid ${colors.lineBreak};
          border-left: 0;
        }

        p {
          padding: 0 ${boxStyles.standardPadding};
          color: ${colors.titleColor};
          text-transform: capitalize;
          font-weight: normal;
          cursor: pointer;
          transition-duration: 1s;
          line-height: 40px;

          &:hover {
            color: ${colors.brandColor};
          }

          span {
            padding: 0 4px;
          }

          .emailRow {
            cursor: pointer;
          }
        }
      }

      input {
        background-color: ${colors.inputBackground};
        border: none;
        border-radius: 8px 0 0 8px;
        padding: ${boxStyles.standardPadding};
        color: ${colors.inputTextColor};
        flex: 1;
        font-size: ${textSizes.normal};

        &::placeholder {
          color: ${colors.placeholderText};
        }
      }
    }

    .newInvite {
      display: flex;
      padding: 15px 10px 5px;
      transition-duration: 1s;
    }

    .button {
      margin: auto;
      padding: ${boxStyles.standardPadding};
      position: relative;
      z-index: 1;
      margin: 7px 0;
      font-size: ${textSizes.normal};
      font-weight: normal;
    }

    .cancel {
      cursor: default;
      border-radius: 10px;
      transition-duration: 1s;
      opacity: 0;
      color: red;
      font-size: ${textSizes.normal};

      &:hover {
        color: #333;
      }
    }
  }

  .formActive {
    .newInvite {
    }
    .cancel {
      opacity: 1;
      cursor: pointer;
    }
    .formInput {
      height: 60px;
      padding: 15px 0 5px;
      opacity: 1;

      input {
      }
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .mobile {
      display: none;
    }
    .desktop.formActive {
      display: flex;
    }
    
    .emailRow {
      margin-right: 30px;
    }
  }
`;
